export default "__VITE_ASSET__BarfVb2V__"